


















































import { Vue, Component } from 'vue-property-decorator';
import Modal from '@/components/widgets/molecules/Modal/Modal.vue';
import Table from '@/components/widgets/organisms/Table/Table.vue';
import ButtonCustom from '@/components/widgets/atoms/ButtonCustom/ButtonCustom.vue';

import {
	SELECT_INTEGRATION_ERROR,
	SELECT_TRANSIT_TRAVEL_DETAIL,
} from '@/store/TransitFacility/travels/actions';

@Component({
	components: {
		Modal,
		Table,
		ButtonCustom,
	},
})
export default class IntegrationOutErrorModal extends Vue {
	/* Data */
	private isLoading: boolean = false;

	private pedido: string = '';

	private listErrorsIntegration: object[] = [];

	/* Computed */
	get showModal() {
		return this.$store.getters.hasSelectedIntegrationOutError;
	}

	get selectedIntegration() {
		return this.$store.getters.getSelectedIntegrationOutError;
	}

	/* Methods */
	resetInfo() {
		this.$store.dispatch(SELECT_INTEGRATION_ERROR, null);
	}

	initInfo() {
		this.isLoading = true;

		this.pedido = this.selectedIntegration.pedido || '';
		const listErrorsString = this.selectedIntegration.mensagemIntegracaoOutsystem || '[]';

		if (listErrorsString.startsWith('[') && listErrorsString.endsWith(']')) {
			this.listErrorsIntegration = listErrorsString
				.slice(1, -1)
				.split(',')
				.map(s => s.trim().replace(/^'(.*)'$/, '$1'));
		} else {
			this.listErrorsIntegration = listErrorsString.split(',').map(s => s.trim());
		}

		this.isLoading = false;
	}

	closeModalError() {
		this.close();
	}

	openEdit() {
		this.$store.dispatch(SELECT_TRANSIT_TRAVEL_DETAIL, this.selectedIntegration.viagem);
		this.close();
	}

	close() {
		this.$bvModal.hide('IntegrationOutErrorModal');
	}
}
